import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class ContactApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/contacts`;
    }

    getContactsByLearnerId(learnerId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/learner/${learnerId}`);
    }

    createContactLearner(contact: any): Observable<any> {
        return this.httpClient.post<any>(`${this.url}/learner`, contact);
    }

    createContactRelative(contact: any): Observable<any> {
        return this.httpClient.post<any>(`${this.url}/relative`, contact);
    }

    deleteContact(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }

    resendVerifyEmail(id: string): Observable<any> {
        return this.httpClient.post<any>(`${this.url}/${id}/resend-verify-email`, {});
    }
}

